import { useEffect } from 'react';
import bus, { CallbackBusType, EventName } from 'modules/bus';

export default function useBusEvent<T>(
  eventType: EventName,
  event: (data: CallbackBusType<T>) => void,
) {
  useEffect(() => {
    bus.addEventListener(eventType, event);

    return () => {
      bus.removeEventListener(eventType, event);
    };
  }, [eventType, event]);
}
